














import Vue from "vue";
import { required, integer } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import LineEditorForm from "../components/LineEditorForm.vue";
import { LineUpdateForm } from "../forms/LineUpdateForm";
import { Shop } from "../../shop/models/Shop";
export default Vue.extend({
  mixins: [dialog],
  components: {
    LineEditorForm
  },
  validations: {
    lineUpdateForm: {
      shop: { required },
      shopName: { required },
      lineKey: { required },
      mcApiKey: { required },
      mcSecretkey: { required }
    }
  },
  data() {
    const shops: Shop[] = [];
    const lineUpdateForm: LineUpdateForm = {
      shopName: "",
      lineKey: "",
      mcApiKey: "",
      mcSecretkey: ""
    };
    return { lineUpdateForm, shops };
  },
  async created() {
    await Promise.all([this.getShops()]);
    await this.getLineById(+this.$route.params.id);
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToLineViewPage() {
      this.$router.push({ name: "LineViewPage" });
    },
    async getLineById(id: number) {
      try {
        const { data } = await (this as any).$dep.lineUseCase.getLineById(id);
        const shop = this.shops.find(shop => {
          return shop.id === data.shopId;
        });

        this.lineUpdateForm = { ...data, shop };
      } catch (error) {
        console.log(error);
      }
    },
    async updateLine(id: number) {
      try {
        await (this as any).$dep.lineUseCase.updateShopLine(
          id,
          this.lineUpdateForm
        );
        if (await (this as any).alertSuccess("Success", "Update Line สำเร็จ")) {
          this.goToLineViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถ Update Shopify นี้ได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update Line",
        "คุณต้องการ Update Line หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateLine(+this.$route.params.id);
      }
    },
    clear() {
      this.$v.$reset();
      this.lineUpdateForm = {
        shopName: "",
        lineKey: "",
        mcApiKey: "",
        mcSecretkey: ""
      };
    }
  }
});
